// Comunicación entre el enlace del pie y el aviso de cookies. El pie es un
// Slice y no comparte árbol de React con el Layout, así que se hablan con un
// evento de `window`.
export const COOKIE_CONSENT_NAME = "gatsby-gdpr-google-analytics"

const OPEN_EVENT = "cookie-consent:open"

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_EVENT))
}

export function onOpenCookieSettings(handler) {
  window.addEventListener(OPEN_EVENT, handler)
  return () => window.removeEventListener(OPEN_EVENT, handler)
}

// El id de medición se lee de las opciones que `gatsby-plugin-gdpr-cookies`
// deja en `window`, para no duplicarlo fuera de `gatsby-config.js`.
function gaTrackingId() {
  return window.gatsbyPluginGDPRCookiesOptions?.googleAnalytics?.trackingId
}

// gtag deja de enviar datos mientras exista `window["ga-disable-<id>"]`.
function setGaDisabled(disabled) {
  const id = gaTrackingId()
  if (id) window[`ga-disable-${id}`] = disabled
}

// Google Analytics guarda `_ga` y `_ga_<id>` en el dominio raíz
// (`.nutricionistamonzo.com`), no en el host, así que se borran probando el
// host y cada dominio padre.
function deleteGaCookies() {
  const names = document.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((name) => name === "_ga" || name.startsWith("_ga_"))
  const parts = window.location.hostname.split(".")
  const domains = [""]
  for (let i = 0; i < parts.length - 1; i++) {
    domains.push(`; domain=.${parts.slice(i).join(".")}`)
  }
  names.forEach((name) =>
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`
    })
  )
}

// Cola de gtag. El plugin crea `window.gtag` al cargar Analytics y reutiliza
// `window.dataLayer`, así que lo que se encola aquí antes le llega en orden.
// gtag exige el objeto `arguments`, no un array.
function gtag() {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
}

function hasAnalyticsConsent() {
  const match = document.cookie.match(`(^|;) ?${COOKIE_CONSENT_NAME}=([^;]*)`)
  return match?.[2] === "true"
}

// Modo de consentimiento básico de Google: la etiqueta solo se carga tras
// aceptar (eso lo hace el plugin) y además se le dice qué se ha consentido.
// Publicidad siempre denegada; analítica según la decisión guardada. Tiene que
// encolarse antes de que el plugin envíe el `config`, desde `onClientEntry`.
export function setDefaultConsent() {
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: hasAnalyticsConsent() ? "granted" : "denied",
  })
}

// Al aceptar se reactiva gtag por si en esta misma visita se había rechazado.
export function enableAnalytics() {
  setGaDisabled(false)
  gtag("consent", "update", { analytics_storage: "granted" })
}

// Al rechazar, también después de haber aceptado: gtag puede estar ya cargado
// en la página, así que se desactiva y se borran sus cookies.
export function disableAnalytics() {
  gtag("consent", "update", { analytics_storage: "denied" })
  setGaDisabled(true)
  deleteGaCookies()
}
